import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Factura.types'
import { IFactura } from './Factura.lib';

export class Factura extends IFactura {

    public static async create( linea: string ): Promise<Factura> {
        let o = new Factura();
        o.Linea = linea;
        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/facturas';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Linea}`;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Factura>; Error?: boolean; }> {

        let a: Array<Factura> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/facturas` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Factura( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }


    public static async URLFactura( facturas: Factura[] ): Promise<string>
    {
        let req = new apiRequest();
        req.path = '/facturas/archivos';
        req.params.facturas = facturas.map( x => x.Empresa+';'+x.Linea ).join( ',' );
        req.params.response_type = 'pdf';
        if ( await req.get() )
        {
            return req.data.u;
        }
    }
}